import type { NextPage } from 'next';
import { HandbookLayout } from '~/common/layouts/handbook-layout';
import Content from '~/features/handbook/mdx/inappropiate-behavior.mdx';
import { routes } from '~/utils/routes';

const Page: NextPage = () => (
  <HandbookLayout
    metaData={{
      title: 'テラーノベルハンドブック',
      noIndex: true,
    }}
    breadcrumbList={[
      {
        name: routes.home.title(),
        path: routes.home.url(),
      },
      {
        name: routes['handbook'].title(),
        path: routes['handbook'].url(),
      },
    ]}
  >
    <Content />
  </HandbookLayout>
);
export default Page;
